import React, { useEffect, useState } from 'react';
import { Badge, Box, Button, Group } from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { DeleteRecords, EditRecord } from '../../Utilities/EditorDeleteRecords';


function Property() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.ProjectOverview_list}/${user.compcode}`)
      .then((response) => {
        if (response.data.status) {
          setData(response.data.data);

        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [user.compcode]);



  const columns = [
    {
      id: 'actions',
      header: 'Actions',
      size: '100',
      Cell: ({ row }) => (
        <Group spacing="xs">
          <EditRecord
            id={row.original.propertyid}
            route="/dashboard/add-property"
          />
          <DeleteRecords
            id={row.original.propertyid}
            endpoint={`${ApiLinks.ProjectOverview_Delete}`}
            compcode={user.compcode}
            onDeleteSuccess={(deletedId) =>
              setData((prev) => prev.filter((item) => item.propertyid !== deletedId))
            }
          />
        </Group>
      ),
    },
    {
      accessorKey: 'propertyname',
      header: 'Property Name',
    },
    {
      accessorKey: 'mainimages',
      header: 'Image',
      Cell: ({ cell }) => {
        const photoPath = cell.getValue();
        const imageUrl = `${process.env.REACT_APP_IMG_URL}/${photoPath}`;
        return (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt="Property"
              style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
            />
          </a>
        );
      },
    },
    {
      accessorKey: 'propertystatus',
      header: 'Status',
      Cell: ({ cell }) => {
        const value = cell.getValue(); // should be true or false
        return (
          <Badge color={value ? 'green' : 'red'} variant="filled">
            {value ? 'Active' : 'Inactive'}
          </Badge>
        );
      },
    },
    {
      accessorKey: 'sortorder',
      header: 'Sort Order',
    },



  ];

  return (
    <Box>
      <Group position="apart" mb="md">
        <h2>Properties List</h2>
        <Button onClick={() => navigate('/dashboard/add-property', { state: { id: null } })}>
          Create
        </Button>
      </Group>

      <CustomMantineTable columns={columns} data={data} loading={loading} />


    </Box>

  );
}

export default Property;
